import React from 'react';

import Upload from './Upload';
import List from './List';

import { Container, Content } from './styles';

import { FileProvider } from '~/context/files';

interface IUploadFilesProps {
  type: string;
  project_temp_id: string;
  project_type: string;
  sequence: number;
  user_id: string;
}

const UploadFiles: React.FC<IUploadFilesProps> = ({
  type,
  project_temp_id,
  project_type,
  sequence,
  user_id,
}) => {
  return (
    <FileProvider>
      <Container>
        <Content>
          <Upload
            type={type}
            project_temp_id={project_temp_id}
            project_type={project_type}
            sequence={sequence}
            user_id={user_id}
          />
          <List />
        </Content>
      </Container>
    </FileProvider>
  );
};

export default UploadFiles;
